export function getCustomAttributes(customAttributes = []) {
  return customAttributes.map(attr => ({
    key: attr.key,
    value: attr.value,
  }))
}
